import PubSub from "underpub-js";

var ListingPosts = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ListingPosts',
	};

	$.extend(true, this.options, options);

};

ListingPosts.prototype.init = function() {

	var self = this;

};

export default ListingPosts;
